import { cn } from "@/src/shared/utils/mergeTwClasses";
import { Box, Card, Stack, Typography } from "@mui/material";
import Image from "next/image";
import React, { FC } from "react";
import { Button } from "../../Button";
import {useAnalytics} from "@/src/components/pages/StepPage/components/useAnalytics/useAnalytics";


export const ProductCard: FC<any> = ({
  title,
  description,
  alt,
  imageUrl,
  className,
  actions = [],
  actionsContainerClassName,
  ...rest
}) => {
  const { callAnalyticEvent } = useAnalytics()

  const isValidUrl = imageUrl && (imageUrl.startsWith("http") || imageUrl.startsWith("/"));
  return (
    <Card
      className={cn("flex h-full min-h-[298px] w-full flex-col p-0", className)}
      {...rest}
    >
      {imageUrl && isValidUrl && (
        <Box className={"mx-auto my-0 w-full"}>
          <Image
            src={imageUrl}
            alt={alt}
            width={400}
            height={190}
            sizes="100vw"
            style={{
              width: "100%",
              height: "190px",
              objectFit: "cover",
            }}
          />
        </Box>
      )}
      <Stack className={"flex-1 gap-4 p-4"}>
        <div className={"flex-1"}>
          {title && (
            <Typography
              component={"span"}
              variant={"h4"}
              sx={{ color: "#234678" }}
            >
              {title}
            </Typography>
          )}
          {description && (
            <Typography component={"p"}>{description}</Typography>
          )}
        </div>
        <Stack
          className={cn(
            "flex-1 gap-2 flex-center-row",
            actionsContainerClassName,
          )}
        >
          {actions.map(
            ({ variant, className, title, href, target, analyticEvent, prefetch, ...rest }: any) => (
              <Button
                variant={variant}
                className={cn("w-full", className)}
                key={title}
                onClick={() => {
                  const [eventName, eventParams = {}] = analyticEvent ?? [];
                  eventName && callAnalyticEvent(eventName, eventParams);
                }}
                href={href || "/"}
                target={target}
                {...rest}
              >
                {title}
              </Button>
            ),
          )}
        </Stack>
      </Stack>
    </Card>
  );
};
